import { Col, Row } from "react-bootstrap";
import Profile from "shared/components/data-display/card/Profile";
import styled from "styled-components";

export const MoreMenuContainer = styled.div`
    margin-left: -70px;
    display: inline-flex;
`;

export const Wrapper = styled(Row)`
    border-bottom: ${globalThis.config.border.small};
    background-color: ${(props) =>
        props.selected
            ? globalThis.config.colors.gray9
            : globalThis.config.colors.white};
    margin: 0;
    &:hover {
        background: ${(props) => !props.selected && globalThis.config.colors.gray9};
    }
    ,
    &:hover #moreButton {
        margin-left: 0px;
        display: flex;
        -ms-flex-align: center;
        -webkit-align-items: center;
        -webkit-box-align: center;
        align-items: "center";
        justify-content: "center";
    }

    &:hover .rightArrow {
        path,
        circle {
            stroke: ${globalThis.config.colors.black};
        }
    }
    &:hover .downArrow {
        path,
        circle {
            stroke: ${globalThis.config.colors.black};
        }
    }

    .rightArrow {
        path,
        circle {
            stroke: ${globalThis.config.colors.gray3};
        }
    }

    .downArrow {
        path,
        circle {
            stroke: ${globalThis.config.colors.black};
        }
    }
`;

export const IndentColumn = styled(Col)`
    flex: 0 0 4%;
`;

export const Column = styled(Col)`
    border-right: ${globalThis.config.border.small};
    padding: 0;
    &:last-child {
        border-right: none;
    }
    &:hover #moreButton {
        display: flex;
        -ms-flex-align: center;
        -webkit-align-items: center;
        -webkit-box-align: center;
        align-items: "center";
        justify-content: "center";
    }
`;

export const WrapperEmployee = styled.div`
    display: flex;
`;

export const WrapperAction = styled.div`
    display: flex;
    min-width: 1.25rem;
    width: 1.25rem;
    max-width: 1.25rem;
    align-items: center;
`;

export const StyledEmployeeProfile = styled(Profile)`
    width: 100%;
`;

export const IconButton1 = styled.button`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
`;

export const IconButton2 = styled.button`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    display: none;
`;
